import { TableCell } from "@mui/material"

export function TextOnlyFieldHeader({ item: { field, label, align } }) {
    return (
        <TableCell align={align} data-cy={`header-${field}`}>
            {label ?? field?.titleize() ?? ""}
        </TableCell>
    )
}
